const state = {
    getServer: '',
}

const mutations = {
    SET_SERVER(state, payload) {
        state.getServer = payload
    }
}

const getters = {
    getServer: state => state.getServer
}

export default {
    state,
    mutations,
    getters
}
